import it from "vuetify/lib/locale/it";
import { Translations } from "./language-translations";
import * as salePageBlockFills from "./it/sale_page_blocks";
export default {
  rtl: false,
  ...it,
  ...Translations.it,
  sale_page_block_fills: salePageBlockFills.default,
  components: {
    gallery_block: {
      trust_badges: {
        free_shipping: 'Spedizione gratuita',
        return_guarantee: 'Garanzia di reso',
        secure_payment: 'Pagamento sicuro',
        fast_support: 'Supporto rapido'
      }
    }
  },
  sale_page_page: {
    sale_page_form: {
      fields: {
        custom_data: {
          shipping: {
            delivery_text: {
              default: 'Data di consegna'
            }
          },
          reviews: {
            reviews_text: '{rating} ({count} Recensione(i))'
          }
        }
      }
    }
  }
};